<template>
    <div class="biz-financial-chart">
        <!-- <div class="chart-dashbord income-detail">
            <div class="income-chart">
                <div class="chart-dashbord-head">
                    <div class="title">
                        收支情況
                    </div>
                    <div class="tips">
                        <div>
                            <div class="dot income"></div>
                            收入
                        </div>
                        <div>
                            <div class="dot expense"></div>
                            支出
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="value">
                        <ul>
                            <li v-for="(item, index) in maxTotalSlice" :key="index">{{item}}</li>
                        </ul>
                    </div>
                    <div class="bar-chart-content">
                        <div class="bar-chart-group">
                            <div class="single-bar" v-for="(item, index) in inComeAndExpenseChart.chart" :key="index">
                                <svg class="bar-chart" width="25" height="210" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                    <path class="bar"
                                        @mouseenter="showIncome(index, item.income)"
                                        @mouseleave="hideIncome(index)"
                                        :stroke-dasharray="getBarChartPercent(item.income)+',210'"
                                        stroke="#3942b5" stroke-width="5" stroke-linecap="round"
                                        d="M5 213 V15"
                                    >
                                    </path>
                                    <path class="bar"
                                        @mouseenter="showExpense(index, item.expense)"
                                        @mouseleave="hideExpense(index)"
                                        :stroke-dasharray="getBarChartPercent(item.expense)+',210'"
                                        stroke="#fc7171" stroke-width="5" stroke-linecap="round"
                                        :d="'M'+inComeAndExpenseChart.charPadding+' 213 V15'"
                                    />
                                </svg>
                                <div class="income-amount">收入：$ {{toCurrency(item.income)}}</div>
                                <div class="expense-amount">支出：$ {{toCurrency(item.expense)}}</div>
                                <div v-if="inComeAndExpenseChart.filter == 'YEAR'" class="date">
                                    {{toDoubleNum(index+1)}} <span>月</span> 
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'SEASON'" class="date">
                                    {{getSeason(index)}} <span>月</span> 
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'MONTH'" class="date">
                                    {{toDoubleNum(index+1)}}
                                </div>
                                <div v-if="inComeAndExpenseChart.filter == 'WEEK'" class="date">
                                    {{getDate(Math.abs(index-6)*-1)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="income-expense">
            <div class="chart-dashbord left">
                <div class="chart-dashbord-head">
                    <div class="title">
                        收入排名
                    </div>
                </div>
                <div class="table-list">
                    <div class="table-list-title not-fixed">
                        <span class="ranking">排名</span>
                        <span class="group">業務分群</span>
                        <span class="income">收入</span>
                        <span class="rented">出租 / 總間數</span>
                    </div>
                    <div class="table-list-body">
                        <div v-show="rankingList.length === 0" class="is-empty">0 筆資料</div>
                        <ul>
                            <li v-for="(item, index) in loopLimit" :key="index" @click="setGroupReport({groupId: item.groupId, groupName: item.groupName})">
                                <span class="ranking">
                                    <img v-if="index === 0" src="@/assets/img/icon/medals_one.svg" alt="">
                                    <img v-if="index === 1" src="@/assets/img/icon/medals_two.svg" alt="">
                                    <img v-if="index === 2" src="@/assets/img/icon/medals_three.svg" alt="">
                                    <span v-else></span>
                                    {{index+1}}
                                </span>
                                <span class="group">{{item.groupName}}</span>
                                <span class="income">{{toCurrency(item.income)}}</span>
                                <span class="rented">{{item.rentedHouse}} / {{item.totalHouse}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="chart-dashbord right">
                <div class="arears">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            累積總收明細
                        </div>
                    </div>
                    <div class="content">
                        <div class="sub-title">
                            帳單收入
                        </div>
                        <div class="block">
                            <div class="item">
                                <span class="title">
                                    租金
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.billIncomeRent), 'blue': isPositive(incomeList.billIncomeRent)}">
                                    <span v-if="!isPositive(incomeList.billIncomeRent)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.billIncomeRent?toCurrency(Math.abs(incomeList.billIncomeRent)):0}}
                                </div>
                            </div>
                            <div class="item" >
                                <span class="title">
                                    雜項
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.billIncomeOther), 'blue': isPositive(incomeList.billIncomeOther)}">
                                    <span v-if="!isPositive(incomeList.billIncomeOther)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.billIncomeOther?toCurrency(Math.abs(incomeList.billIncomeOther)):0}}
                                </div>
                            </div>
                            <div class="item">
                                <span class="title">
                                    押金
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.billIncomeDeposit), 'blue': isPositive(incomeList.billIncomeDeposit)}">
                                    <span v-if="!isPositive(incomeList.billIncomeDeposit)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.billIncomeDeposit?toCurrency(Math.abs(incomeList.billIncomeDeposit)):0}}
                                </div>
                            </div>
                        </div>
                        <div class="sub-title">
                            記帳收入
                        </div>
                        <div class="block">
                            <div class="item">
                                <span class="title">
                                    租金
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.ledgerIncomeRent), 'blue': isPositive(incomeList.ledgerIncomeRent)}">
                                    <span v-if="!isPositive(incomeList.ledgerIncomeRent)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.ledgerIncomeRent?toCurrency(Math.abs(incomeList.ledgerIncomeRent)):0}}
                                </div>
                            </div>
                            <div class="item">
                                <span class="title">
                                    雜項
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.ledgerIncomeOther), 'blue': isPositive(incomeList.ledgerIncomeOther)}">
                                    <span v-if="!isPositive(incomeList.ledgerIncomeOther)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.ledgerIncomeOther?toCurrency(Math.abs(incomeList.ledgerIncomeOther)):0}}
                                </div>
                            </div>
                            <div class="item">
                                <span class="title">
                                    押金
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.ledgerIncomeDeposit), 'blue': isPositive(incomeList.ledgerIncomeDeposit)}">
                                    <span v-if="!isPositive(incomeList.ledgerIncomeDeposit)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.ledgerIncomeDeposit?toCurrency(Math.abs(incomeList.ledgerIncomeDeposit)):0}}
                                </div>
                            </div>
                        </div>
                        <div class="sub-title">
                            其他收入
                        </div>
                        <div class="block">
                            <div class="item">
                                <span class="title">
                                    取消預定
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.bookingRefund), 'blue': isPositive(incomeList.bookingRefund)}">
                                    <span v-if="!isPositive(incomeList.bookingRefund)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.bookingRefund?toCurrency(Math.abs(incomeList.bookingRefund)):0}}
                                </div>
                            </div>
                            <div class="item">
                                <span class="title">
                                    委託退款
                                </span>
                                <div class="amount" :class="{'red': !isPositive(incomeList.taskRefund), 'blue': isPositive(incomeList.taskRefund)}">
                                    <span v-if="!isPositive(incomeList.taskRefund)" class="sign">
                                        -
                                    </span>
                                    {{incomeList.taskRefund?toCurrency(Math.abs(incomeList.taskRefund)):0}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="statics">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            累積支出明細
                        </div>
                    </div>
                    <div class="doughnut-content">
                       <div class="content">
                            <div class="sub-title">
                                代收出帳
                            </div>
                            <div class="block">
                                <div class="item" >
                                    <span class="title">
                                        租金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.billExpenseRent), 'blue': isPositive(incomeList.billExpenseRent)}">
                                        <span v-if="!isPositive(incomeList.billExpenseRent)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.billExpenseRent?toCurrency(Math.abs(incomeList.billExpenseRent)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        雜項
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.billExpenseOther), 'blue': isPositive(incomeList.billExpenseOther)}">
                                        <span v-if="!isPositive(incomeList.billExpenseOther)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.billExpenseOther?toCurrency(Math.abs(incomeList.billExpenseOther)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        押金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.billExpenseDeposit), 'blue': isPositive(incomeList.billExpenseDeposit)}">
                                        <span v-if="!isPositive(incomeList.billExpenseDeposit)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.billExpenseDeposit?toCurrency(Math.abs(incomeList.billExpenseDeposit)):0}}
                                    </div>
                                </div>
                            </div>
                            <div class="sub-title">
                                記帳出帳
                            </div>
                            <div class="block">
                                <div class="item">
                                    <span class="title">
                                        租金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.ledgerExpenseRent), 'blue': isPositive(incomeList.ledgerExpenseRent)}">
                                        <span v-if="!isPositive(incomeList.ledgerExpenseRent)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.ledgerExpenseRent?toCurrency(Math.abs(incomeList.ledgerExpenseRent)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        雜項
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.ledgerExpenseOther), 'blue': isPositive(incomeList.ledgerExpenseOther)}">
                                        <span v-if="!isPositive(incomeList.ledgerExpenseOther)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.ledgerExpenseOther?toCurrency(Math.abs(incomeList.ledgerExpenseOther)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        押金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.ledgerExpenseDeposit), 'blue': isPositive(incomeList.ledgerExpenseDeposit)}">
                                        <span v-if="!isPositive(incomeList.ledgerExpenseDeposit)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.ledgerExpenseDeposit?toCurrency(Math.abs(incomeList.ledgerExpenseDeposit)):0}}
                                    </div>
                                </div>
                            </div>
                            <div class="sub-title">
                                其他出帳
                            </div>
                            <div class="block">
                                <div class="item">
                                    <span class="title">
                                        記帳支出
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.ledgerExpenseCost), 'blue': isPositive(incomeList.ledgerExpenseCost)}">
                                        <span v-if="!isPositive(incomeList.ledgerExpenseCost)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.ledgerExpenseCost?toCurrency(Math.abs(incomeList.ledgerExpenseCost)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        委託獎金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.taskBonus), 'blue': isPositive(incomeList.taskBonus)}">
                                        <span v-if="!isPositive(incomeList.taskBonus)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.taskBonus?toCurrency(Math.abs(incomeList.taskBonus)):0}}
                                    </div>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
                <div class="statics">
                    <div class="chart-dashbord-head">
                        <div class="title">
                            屋主請款明細
                        </div>
                    </div>
                    <div class="doughnut-content">
                       <div class="content">
                            <div class="block">
                                <div class="item" >
                                    <span class="title">
                                        租金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.landlordQuoteRent), 'blue': isPositive(incomeList.landlordQuoteRent)}">
                                        <span v-if="!isPositive(incomeList.landlordQuoteRent)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.landlordQuoteRent?toCurrency(Math.abs(incomeList.landlordQuoteRent)):0}}
                                    </div>
                                </div>
                                <div class="item">
                                    <span class="title">
                                        雜項
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.landlordQuoteOther), 'blue': isPositive(incomeList.landlordQuoteOther)}">
                                        <span v-if="!isPositive(incomeList.landlordQuoteOther)">
                                            -
                                        </span>
                                        {{incomeList.landlordQuoteOther?toCurrency(Math.abs(incomeList.landlordQuoteOther)):0}}
                                    </div>
                                </div>
                                <div class="item" >
                                    <span class="title">
                                        押金
                                    </span>
                                    <div class="amount" :class="{'red': !isPositive(incomeList.landlordQuoteDeposit), 'blue': isPositive(incomeList.landlordQuoteDeposit)}">
                                        <span v-if="!isPositive(incomeList.landlordQuoteDeposit)" class="sign">
                                            -
                                        </span>
                                        {{incomeList.landlordQuoteDeposit?toCurrency(Math.abs(incomeList.landlordQuoteDeposit)):0}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { 
    apiBizGetIncomeAndExpenditureStatistics,
    apiBizGetOccupancyRate,
    apiBizGetReceivable
    } from "@/apis/api.js";
export default {
    data () {
        return {
            inComeAndExpenseChart: {
                filter: 'WEEK',
                charPadding: 17,
                income:{
                },
                expense:{
                },
                dounutPercent: 0,
                chart:[]
            },
            OccupancyChart: {},
            receivable: {
                filter: 'WEEK',
                paidAmount: 0,
                unpaidAmount: 0,
                totalAmount: 0,
            }
        }
    },
    created () {
        // this.getIncomeAndExpenditureStatistics()
        // this.getReceivable()
        // this.getOccupancyRate()
        this.$store.dispatch('getBizReportOverViewIncomeList', null)
        this.$store.dispatch('getBizReportOverViewRankingList')
    },
    watch: {
        // groupId: {
        //     handler: function (val) {
        //         if(val){
        //         }
        //     },
        //     immediate: true
        // }
    },
    methods: {
        getIncomeAndExpenditureStatistics: function () {
            let data = this.inComeAndExpenseChart.filter
            if(data == 'WEEK'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'MONTH'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'SEASON'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }else if(data == 'YEAR'){
                this.inComeAndExpenseChart.chart = [
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                    {
                        expense: 0,
                        income: 0
                    },
                ]
            }
           
            apiBizGetIncomeAndExpenditureStatistics(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.inComeAndExpenseChart.chart = res.data.result.analysisData
                    this.inComeAndExpenseChart.expense = res.data.result.expenseData
                    this.inComeAndExpenseChart.income = res.data.result.incomeData
                    this.inComeAndExpenseChart.totalAmount = res.data.result.totalAmount
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getReceivable: function () {
            let data = this.receivable.filter
            apiBizGetReceivable(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.receivable.paidAmount = res.data.result.paidAmount
                    this.receivable.unpaidAmount = res.data.result.unpaidAmount
                    this.receivable.totalAmount = res.data.result.totalAmount
                    
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getOccupancyRate: function () {
            apiBizGetOccupancyRate()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.OccupancyChart = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getDecimal: function (value) {
            let numLength = value.toString().length
            let toDecimal = ''
            for (let i = 0; i < numLength-3; i++) {
                toDecimal += '0'
            }
            toDecimal = '0.'+toDecimal+'1'
            return parseFloat(toDecimal)
        },
        getInteger: function (value) {
            let numLength = value.toString().length
            let toInteger = ''
            for (let i = 0; i < numLength-2; i++) {
                toInteger += '0'
            }
            toInteger = '1'+toInteger
            return parseInt(toInteger)
        },
        getBarChartPercent: function (value) {
            let maxTotal = this.carryNum?this.carryNum:40000
            return (value/maxTotal)*210
        },
        getMax: function (value) {
            let max = 0
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.expense > max) {
                    max = element.expense;
                }
            }
            for (let i = 0; i < value.length; i++) {
                const element = value[i];
                if (element.income > max) {
                    max = element.income;
                }
            }
            return max
        },
        getDate: function (index) {
            let date = new Date()
            let newDate = new Date()
            newDate.setDate(date.getDate() + index)
            let time = (newDate.getMonth()+1)+'.'+newDate.getDate()

            return time
        },
        getSeason: function (index) {
            let today = new Date()
            let nowMonth = today.getMonth()+1
            let season = []
            if( nowMonth <= 3 ){
                season = [1,2,3]
            }else if(nowMonth >= 4 && nowMonth <= 6){
                season = [4,5,6]
            }else if(nowMonth >= 7 && nowMonth <= 9){
                season = [7,8,9]
            }else if(nowMonth >= 10 && nowMonth <= 12){
                season = [10,11,12]
            }
            return this.toDoubleNum(season[index])

        },
        filterEvent: function (type, filter) {
            if(type == 'income'){
                this.inComeAndExpenseChart.filter = filter
            }else if( type == 'receivable'){
                this.receivable.filter = filter
            }
        },
        showIncome: function(index, value) {
            console.log(document.getElementsByClassName('income-amount'))
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            let barHeight = this.getBarChartPercent(value)+10
            incomeItem.style.bottom = barHeight+'px'
            incomeItem.style.display = 'flex'
        },
        hideIncome: function(index, value) {
            let incomeItem = document.getElementsByClassName('income-amount')[index]
            incomeItem.style.display = 'none'
        },
        showExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            let barHeight = this.getBarChartPercent(value)+10
            expenseItem.style.bottom = barHeight+'px'
            expenseItem.style.display = 'flex'
        },
        hideExpense: function(index, value) {
            let expenseItem = document.getElementsByClassName('expense-amount')[index]
            expenseItem.style.display = 'none'
        },
        setGroupReport: function (data) {
            if(this.isAllGroup){
                this.$store.dispatch('getBizReportOverViewIncomeList', data.groupId)
                this.$store.dispatch('setGroupName', data.groupName)
            }
        },
        toDoubleNum: function (value) {
            return (Array(2).join(0)+value).slice(-2)
        },
        isPositive: function (value) {
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        }
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        maxTotalSlice: function () {
            let maxTotal  = this.carryNum?this.carryNum:40000
            
            let slice = []
            for (let i = 0; i <= 4; i++) {
                // console.log((maxTotal/4)*i)
                slice[i] = (maxTotal/4)*i
            }
            return slice.reverse()
        },
        carryNum: function (value) {
            
            let maxValue  = parseInt(this.maxValue)
            let toMutiple = maxValue*1.1
            let toDecimal = this.getDecimal(maxValue)
            let toInteger = this.getInteger(maxValue)

            

            let toCeil = Math.ceil(toMutiple*toDecimal)
            let toMaxTotal = toCeil*toInteger
            // console.log('最高金額:'+maxValue)
            // console.log('最高金額*1.1:'+toMutiple)
            // console.log('變小數:'+toDecimal)
            // console.log('無條件進位:'+toInteger)
            // console.log('還原:'+toCeil)
            // console.log(toDecimal)
            // console.log(toInteger)
            // console.log(toMaxTotal)
            return toMaxTotal
        },
        maxValue: function (){
            let chart = this.inComeAndExpenseChart.chart
            return this.getMax(chart)
        },
        dounutPercent: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)

            let percent = parseInt((income/(income+expense))*100)

            if(percent){
                return percent
            }else{
                return 0
            }
        },
        isOnlyExpnese: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)
            // console.log(income)
            // console.log(expense)
            if(expense > income && income == 0){
                return true
            }else{
                return false
            }
        },
        occupancyPercent: function () {
            let rented = parseInt(this.OccupancyChart.rentedCount)
            let empty = parseInt(this.OccupancyChart.notRentedCount)

            let percent = parseInt((empty/(rented+empty))*100)
            if(percent){
                return percent
            }else{
                return 0
            }
        },
        receivablePercent: function () {
            let paid = parseInt(this.receivable.paidAmount)
            let unpaid = parseInt(this.receivable.unpaidAmount)
            let percent = parseInt((paid/(paid+unpaid))*100)
            
            if(percent){
                return percent
            }else{
                return 0
            }
        },
        isOnlyUnpaid: function () {
            let paid = parseInt(this.receivable.paidAmount)
            let unpaid = parseInt(this.receivable.unpaidAmount)
            // console.log(income)
            // console.log(expense)
            if(unpaid > paid && paid == 0){
                return true
            }else{
                return false
            }
        },
        isIncomePositive: function () {
            let income = parseInt(this.inComeAndExpenseChart.income.totalAmount)
            let expense = parseInt(this.inComeAndExpenseChart.expense.totalAmount)

            if( (income - expense) >= 0 ){
                return '+'
            }else{
                return '-'
            }
        },
        loopLimit: function () {
            return this.rankingList.slice(0, 5)
        },
        ...mapGetters({
            incomeList: 'GET_BIZ_REPORT_OVER_VIEW_INCOME_LIST',
            rankingList: 'GET_BIZ_REPORT_OVER_VIEW_RANKING_LIST',
            groupId : 'GET_BIZ_USER_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
        })
    }
}
</script>
<style lang="scss">
.biz-financial-chart{
    position: relative;
    width: 1140px;
    .income-amount,
    .expense-amount{
        position: absolute;
        display: none;
        align-items: center;
        justify-content: center;
        min-width: 115px;
        left: 7px;
        border-radius: 4px;
        background-color: #676362;
        color: #fff;
        font-size: 12px;
        padding: 8px 3px;
        z-index: 20;
        top: 50px;
    }
    .expense-amount{
        left: 21px;
    }
    .income-amount::before,
    .expense-amount::before{
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        left: -4px;
        border-style: solid;
        border-width: 3px 4px 3px 0;
        border-color: transparent #676362 transparent transparent;
    }
    .chart-dashbord{
        background: #fff;
        border-radius: 8px;
        box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
        .chart-dashbord-head{
            display: flex;
            align-items: center;
        }
        .title{
            font-size: 20px;
            font-weight: 500;
        }
        .tips{
            display: flex;
            align-items: center;
            >div{
                display: flex;
                align-items: center;
                color: #676362;
                font-size: 12px;
                .dot{
                    position: relative;
                    background: #000;
                    width: 7px;
                    height: 7px;
                    border-radius: 4.5px;
                    margin-right: 8px;
                }
            }
        }
    }
    .income-chart{
        border-bottom: solid 1px #f3f3f3;
        padding: 24px 30px;
        padding-bottom: 50px;
        .tips{
            position: absolute;
            right: 30px;
            >div{
                margin-left: 20px;
            }
            .dot.income{
                background: #3942b5;
            }
            .dot.expense{
                background: #fc7171;
            }
        }
        .filter-tabs{
            margin-left: 30px;
        }
        .content{
            display: flex;
            align-items: flex-end;
            .value{
                margin-right: 12px;
                position: relative;
                bottom: -10px;
                li{
                    text-align: center;
                    color: #a8a5a4;
                    line-height: 1.83;
                    font-size: 12px;
                    margin-top: 32px;
                }
            }
            .bar-chart-content{
                width: 1048px;
                height: 211px;
                background-image: url('../../../../assets/img/component/financial_chart/chart_dash.png');
                .bar-chart-group{
                    position: relative;
                    display: flex;
                    align-items: flex-end;
                    bottom: 2px;
                    margin-left: 40px;
                    .date{
                        color: #676362;
                        margin-top: 7px;
                    }
                }
                .bar-chart-group.week{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 58px;
                    }
                    .single-bar:nth-child(even){
                        .date{
                            color: #a8a5a4;
                        }
                    }
                }
                .bar-chart-group.month{
                    margin-left: 10px;
                    .single-bar{
                        margin-right: 9px;
                    }
                    .single-bar:nth-child(even){
                        .date{
                            color: #a8a5a4;
                        }
                    }
                }
                .bar-chart-group.season{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 58px;
                        .date{
                            >span{
                                font-size: 10px;
                            }
                        }
                    }
                }

                .bar-chart-group.year{
                    margin-left: 60px;
                    .single-bar{
                        margin-right: 50px;
                        .date{
                            width: 31px;
                            >span{
                                font-size: 10px;
                            }
                        }
                    }
                }

            }
        }
        .chart-date{
            margin-top: 12px;
            margin-left: 100px;
            ul{
                display: flex;
                align-items: center;
                li{
                    color: #676362;
                    margin-right: 50px;
                }
            }
        }
    }
    .income-expense{
        display: flex;
        margin-top: 30px;
        .left{
            position: relative;
            width: 478px;
            margin-right: 20px;
            .chart-dashbord-head{
                padding: 20px 24px 12px 24px;
            }
            .page-setting.fixed .table-list .table-list-title {
                position: relative;
                width: unset;
            }
            .table-list{
                width: 100%;
                border-radius: 0;
                border-left: none;
                border-right: none;
                border-bottom: none;
                box-sizing: border-box;
                .not-fixed{
                    position: relative;
                    top: unset;
                    z-index: 1;
                    width: unset;
                }
                .table-list-body ul li{
                    align-items: flex-start;
                    cursor: pointer;
                }
                .ranking{
                    width: 60px;
                    margin-right: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        // margin-right: 22px;
                    }
                }
                .group{
                    width: 61px;
                    margin-right: 25px;
                }
                .income{
                    width: 90px;
                    margin-right: 45px;
                    text-align: right;
                }
                .table-list-body ul li .income{
                    color: #fc7171;
                }
                .rented{
                    width: 90px;
                }
            }
        }
        .right{
            position: relative;
            width: 642px;
            padding: 20px 24px;
            box-sizing: border-box;
            .chart-dashbord-head{
                margin-bottom: 16px;
            }
            .content{
                margin-bottom: 37px;
                .sub-title{
                    position: relative;
                    font-weight: 500;
                    color: #ff9275;
                    margin-bottom: 12px;
                    margin-left: 10px;
                    &::before{
                        content: '';
                        position: absolute;
                        height: 17px;
                        width: 3px;
                        left: -10px;
                        border-radius: 50px;
                        background: #ff9275;
                    }
                }
                .block{
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                    .item{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-radius: 4px;
                        border: solid 1px #f3f3f3;
                        padding: 7px 12px;
                        width: 186px;
                        box-sizing: border-box;
                        margin-right: 12px;
                        .title{
                            width: 56px;
                            margin-right: 8px;
                            font-size: 14px;
                        }
                        .amount{
                            &.red {
                                color: #fc7171;
                            }
                            &.blue{
                                color: #3942b5;
                            }
                        }
                    }
                }
            }
        }
    }
    .single-bar{
        bottom: -3px;
        position: relative;
        .bar {
            animation: bar-progress 1s ease-out forwards;
        }
    }
    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }
    @keyframes bar-progress {
        0% {
            stroke-dasharray: 0 200;
        }
    }
    
}
    
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/reportOverview/financialChart.vue